<mwe-form [formModel]="countryFormModel()" (formChanged)="onChanges()" />

@if (useManualAddressForm()) {
  <mwe-manual-address-input [initialData]="manualAddress()" (formChanged)="receiveSelectionFinished($event)" />
  <mwe-button-link
    (click)="resetForm()"
    label="address-input.manualSearch.button-back"
    prependIconClass="fa fa-arrow-left"
    customCss="mb-3"
  />
} @else {
  <mwe-address-search-wrapper
    [ignoreAvailableZipCodes]="true"
    [selectedOlav]="initialOlavEntry()"
    (addressInputCompleted)="receiveSelectionFinished($event)"
    (noResultsFound)="changeToManualAddressForm()"
  />
}
